import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function ErrorPage() {
  return (
    <div className="d-flex flex-column flex-root vh-100">
      <div
        className="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/error/bg1.jpg")})`,
        }}
      >
        <h1 className="font-size-sm-100 font-weight-boldest text-dark-75 mt-15" style={{ fontSize: "150px" }}>
          404
        </h1>
        <p className="font-size-h3 font-weight-light">Page not found!</p>
        <Link to={`/`} className="text-dark-75">
          <Button style={{ width: "24.5rem" }} variant="secondary">
            Go Back
          </Button>
        </Link>
      </div>
    </div>
  );
}
